/**
 * Menu
 * @version 2.0.0
 */
class menu {
  constructor() {
    this.menu = ".js-menu";
    this.item = ".rt-menu__item";
    this.submenu = ".rt-menu__submenu";
    this.arrow = ".rt-menu__arrow";
    this.animateIn = "data-animatein";
    this.animateOut = "data-animateOut";
    this.duration = "data-duration";

    this.listener();
  }

  listener() {
    const menus = document.querySelectorAll(this.menu);

    menus.forEach((menu) => {
      const options = {
        items: menu.querySelectorAll(this.item),
        arrows: menu.querySelectorAll(this.arrow),
        animateIn: menu.getAttribute(this.animateIn),
        animateOut: menu.getAttribute(this.animateOut),
        duration: menu.getAttribute(this.duration),
      };
      if (menu.classList.contains("rt-menu--vertical")) {
        this.vertical(options);
      } else {
        this.horizontal(options);
      }
    });
  }

  horizontal(option) {
    const items = option.items;
    const animateIn = option.animateIn;
    const animateOut = option.animateOut;
    const duration = option.duration;

    items.forEach((item) => {
      item.addEventListener("mouseenter", (event) => {
        const el = event.currentTarget;
        const submenu = el.querySelector(this.submenu);

        item.classList.add("is-active");

        if (submenu !== null) {
          animateCSS(submenu, option.animateIn, "300");
        }
      });

      item.addEventListener("mouseleave", (event) => {
        const el = event.currentTarget;
        const submenu = el.querySelector(this.submenu);

        item.classList.remove("is-active");

        if (submenu !== null) {
          animateCSS(submenu, option.animateOut, "300");
        }
      });
    });
  }

  vertical(option) {
    const items = option.items;
    const animateIn = option.animateIn;
    const animateOut = option.animateOut;
    const duration = option.duration;
    const arrows = option.arrows;

    // Enable parent-link toggling with the menu item's is-submenu-toggle CSS class.
    arrows.forEach((arrow) => {
      const item = arrow.parentNode;
      const submenu = item.querySelector(this.submenu);
      const link = item.classList.contains("is-submenu-toggle")
        ? Array.from(item.children).find((child) => child.matches("a"))
        : null;

      if (submenu === null) {
        return;
      }

      const toggleSubmenu = (event) => {
        event.preventDefault();
        if (item.classList.contains("is-active")) {
          arrow.classList.remove("is-active");
          item.classList.remove("is-active");
          slideUp(submenu);
        } else {
          arrow.classList.add("is-active");
          item.classList.add("is-active");
          slideDown(submenu);
        }
      };

      arrow.addEventListener("click", toggleSubmenu);
      if (link) {
        link.addEventListener("click", toggleSubmenu);
      }
    });
  }
  
}

new menu;
